import produce from "immer";

import {
  QUIZ4_DATA_WATCH,
  QUIZ4_DATA_UPDATE,
  QUIZ4_META_WATCH
} from "../actions/types";

const initialState = {
  data: null,
  meta: null
};

export default (state = initialState, action) => {
  return produce(state, draft => {
    // eslint-disable-next-line
    switch (action.type) {
      case QUIZ4_DATA_WATCH:
        draft.data = action.payload.data;
        break;
      case QUIZ4_META_WATCH:
        draft.meta = action.payload.meta;
        break;
      case QUIZ4_DATA_UPDATE:
        console.log("no reducer update");
        break;
    }
  });
};
